import { SketchPicker } from "react-color";
import { makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";

const ColorPicker = ({ changeColor, index = 0, inputColor }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [colorSelected, setColorSelected] = useState("");
  const useStyles = makeStyles((theme) => ({
    color: {
      borderRadius: "2px",
      background: colorSelected,
      display: "inline-block",
      width: theme.spacing(4),
      height: "16px",
      paddingRight: theme.spacing(1),
      cursor: "pointer",
    },
    swatch: {
      padding: "9px 4px",
      background: "#fff",
      borderRadius: theme.spacing(0.5),
      display: "inline-block",
      cursor: "pointer",
      width: "100%",
      border: "0.5px solid #e6e6e6",
      height: theme.spacing(5),
    },
    popover: {
      position: "absolute",
      zIndex: "2",
    },
    cover: {
      position: "fixed",
      top: "0px",
      right: "0px",
      bottom: "0px",
      left: "0px",
    },
    hexCode: {
      borderLeft: "1px solid #ccc",
      paddingLeft: theme.spacing(1),
      marginLeft: theme.spacing(1),
      fontWeight: 600,
    },
    rgbaCode: {
      borderLeft: "1px solid #ccc",
      paddingLeft: theme.spacing(1),
      marginLeft: theme.spacing(1),
      fontWeight: 600,
    },
    arrowIconSection: {
      float: "right",
    },
    arrowIcon: {
      color: "#757575",
    },
  }));

  const classes = useStyles();

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (color) => {
    setColorSelected(color.hex);
    changeColor(color.hex, index);
    const rgbaColor = color.rgb;
  };

  useEffect(() => {
    setColorSelected(inputColor);
  }, [inputColor]);

  return (
    <div>
      <span className={classes.color} onClick={handleClick}>
        &nbsp;
      </span>

      {displayColorPicker ? (
        <div className={classes.popover}>
          <div className={classes.cover} onClick={handleClose} />
          <SketchPicker color={colorSelected} onChange={handleChange} />
        </div>
      ) : null}
    </div>
  );
};

export default ColorPicker;
